import axios from 'axios'

const API_PATH = 'api/v2/admins/products/categories'

const ProductCategoriesApiV2 = {
  /**
   * Get collection of Product Category
   */
  get: async () => {
    const path = API_PATH

    const response = axios.get(path)
    return response
  },

  /**
   * Get collection of Product Size by category
   * @param {number} id - Product Category ID
   */
  getSizes: async (
    id,
    gender
  ) => {
    const path = `${API_PATH}/${id}/sizes`

    const params   = {
      gender: gender
    }
    const response = axios.get(path, { params })
    return response
  }
}

export default ProductCategoriesApiV2
